import { TFunction } from 'i18next'
import { string } from 'yup'

import {
  hasLowercaseLetter,
  hasNumber,
  hasSpecialCharacter,
  hasUppercaseLetter,
  MIN_PASSWORD_LENGTH,
} from './passwordRequirements'

export const getPasswordValidationSchema = (t: TFunction) =>
  string()
    .min(MIN_PASSWORD_LENGTH, t('password_validation.min_length', { count: MIN_PASSWORD_LENGTH }))
    .test('lowercase-letter', t('password_validation.lowercase_letter'), (value) => hasLowercaseLetter(value || ''))
    .test('uppercase-letter', t('password_validation.uppercase_letter'), (value) => hasUppercaseLetter(value || ''))
    .test('number', t('password_validation.number'), (value) => hasNumber(value || ''))
    .test('special-character', t('password_validation.special_character'), (value) => hasSpecialCharacter(value || ''))
